"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var Temperature = function Temperature(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    width: "24",
    height: "24"
  }, props), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M13.87,15.76V2.5a2.5,2.5,0,0,0-5,0V15.76a4.5,4.5,0,1,0,5,0ZM11.37,21a1.5,1.5,0,0,1-.5-2.91V7.5a.5.5,0,0,1,1,0V18.09a1.5,1.5,0,0,1-.5,2.91Z",
    style: {
      fill: '#024965'
    }
  }));
};

var _default = Temperature;
exports["default"] = _default;